<template>
  <div class="home">
    <img class="img" src="@/assets/notice.jpg" />
  </div>
</template>

<script>
export default {
  name: 'Notice',
  components: {},
  data () {
    return {}
  },
  mounted () {},
  computed: {}
}
</script>
<style lang="less" scoped>
.home {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: #383945;
  display: flex;
  align-items: center;
  justify-content: center;
}
.img {
  width: 100%;
  min-width: 950px;
}
</style>
